import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authSlice from "./AuthSlice";
import applicationSlice from "./ApplicationSlice";
import userSlice from "./UserSlice";
import billingSlice from "./BillingSlice";
import { setupInterceptors } from "../utils/utils";
import landingPageSlice from "./LangingPageSlice";
import serviceSlice from "./ServiceSlice";
import managerSlice from "./ManagerSlice";

// import { setupInterceptors } from "../utils";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const rootReducer = combineReducers({
  auth: authSlice,
  application: applicationSlice,
  user: userSlice,
  billing: billingSlice,
  landing: landingPageSlice,
  service: serviceSlice,
  manager: managerSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

setupInterceptors(store);

export let persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;
